import VueRouter from 'vue-router'
const Home = ()=> import('@/pages/Home')
const About = ()=> import('@/pages/About')
const News = ()=> import('@/pages/News')
const NewsDet = ()=> import('@/pages/News/detail.vue')
const Download = ()=>  import('@/pages/Download')
const Innovation = ()=> import('@/pages/Innovation')
const Product = () => import('@/pages/Product')
const Module = () => import('@/pages/Product/module.vue')
const Dealer = () => import('@/pages/Product/dealer.vue')
const Solution = () => import('@/pages/Solution')
const Case = () => import('@/pages/Case')
const Sustain = () => import('@/pages/Sustain')

export default new VueRouter({
    mode:'history',
    routes:[
        {
            path: '/fr',
            component: Home
        },
        {
            path: '/fr/about',
            component: About
        },
        {   
            name:'news',
            path: '/fr/news/:p?',
            component: News,
            props({query}){
                return { p:query.p }
            }
        },
        {
            path: '/fr/newsdet',
            component: NewsDet,
            props({query}){
                return { id:query.id }
            }
        },
        {
            name:'load',
            path: '/fr/download',
            component: Download,
            props({query}){
                return { pid:query.pid, cid:query.cid, p:query.p }
            }
        },
        {
            path: '/fr/innovation',
            component: Innovation
        },
        {
            path: '/fr/product',
            component: Product,
            props({query}){
                return { id:query.id }
            }
        },
        {
            path:'/fr/module',
            component: Module,
        },
        {
            path:'/fr/dealer',
            component: Dealer,
        },
        {
            path: '/fr/solution',
            component: Solution,
            props({query}){
                return{ id:query.id }
            }
        },{
            name:'case',
            path:'/fr/case',
            component: Case,
            props({query}){
                return { p:query.p }
            }
        },{
            path:'/fr/sustainability',
            component: Sustain
        }
    ]
})